
(() => {
  if (window.__metalGalleryFallbackLoaded) return;
  window.__metalGalleryFallbackLoaded = true;

  const GALLERY_SELECTOR = 'product-info media-gallery';
  const ITEM_SELECTOR = '.product__media-item';

  const updateGallery = (gallery) => {
    if (!gallery.isConnected) return;

    const items = [...gallery.querySelectorAll(
      `#Slider-Gallery-${CSS.escape(gallery.id.replace('MediaGallery-', ''))} > ${ITEM_SELECTOR}`
    )];

    // Nothing to display if the product has no media.
    if (!items.length) {
      gallery.classList.remove('metal-gallery-fallback');
      return;
    }

    // Keep the original filtering whenever at least
    // one image matches the selected metal.
    const hasMatchingMedia = items.some(
      item => !item.classList.contains('metal-hidden')
    );

    // Only enable fallback when ALL media are metal-hidden.
    gallery.classList.toggle(
      'metal-gallery-fallback',
      !hasMatchingMedia
    );
  };

  const initGallery = (gallery) => {
    if (gallery.dataset.metalFallbackInit === 'true') return;
    gallery.dataset.metalFallbackInit = 'true';

    let frame = null;

    const scheduleUpdate = () => {
      if (frame !== null) return;

      frame = requestAnimationFrame(() => {
        frame = null;
        updateGallery(gallery);
      });
    };

const observer = new MutationObserver((mutations) => {
  const relevantChange = mutations.some((mutation) => {
    if (
      mutation.type === 'attributes' &&
      mutation.target === gallery
    ) {
      return false;
    }

    return true;
  });

  if (relevantChange) {
    scheduleUpdate();
  }
});

    observer.observe(gallery, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });

    scheduleUpdate();
  };

  const scanGalleries = () => {
    document.querySelectorAll(GALLERY_SELECTOR)
      .forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanGalleries, {
      once: true
    });
  } else {
    scanGalleries();
  }

  // Support Shopify theme editor section reloads.
  document.addEventListener(
    'shopify:section:load',
    scanGalleries
  );
})();
